import React from 'react';
import './App.css';
import HomePage from './containers/HomePage';
import Tracking from './containers/Tracking';
import PrimarySearchAppBar from './components/NavHeader';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Footer from './components/Footer';
import NotFound from './containers/NotFound';

function App() {
	return (
		<div className="App">
			<BrowserRouter>
				<PrimarySearchAppBar />
				<Routes>
					<Route path="/" element={<HomePage />} />
					<Route path="/tracking" element={<Tracking />} />
					<Route path="*" element={<NotFound />} />
				</Routes>
				<Footer />
			</BrowserRouter>
		</div>
	);
}

export default App;
